module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/142.cde98475.png";